import React from 'react';

import DateLabel from '@atlaskit/date-label/date-label';

export default function DateLabelNeutral(): React.JSX.Element {
	return <DateLabel label="29 Jul 2026" appearance="neutral" />;
}
